import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsersIllustration = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M55.9633 44.7925C54.7696 38.6347 49.3496 33.9873 42.8402 33.9873C36.3308 33.9873 30.9108 38.6347 29.7171 44.7925C29.4583 46.1214 30.5091 47.3538 31.8612 47.3538H53.8154C55.1713 47.3538 56.2183 46.1253 55.9594 44.7925H55.9633Z",
			fill: "url(#paint0_linear_1992_28141)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.84 30.8465C46.5054 30.8465 49.4769 27.8751 49.4769 24.2096C49.4769 20.5442 46.5054 17.5728 42.84 17.5728C39.1746 17.5728 36.2031 20.5442 36.2031 24.2096C36.2031 27.8751 39.1746 30.8465 42.84 30.8465Z",
			fill: "url(#paint1_linear_1992_28141)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -3.14062,
			y: 22.5952,
			width: 49.002,
			height: 32.7583,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(4px)",
					clipPath: "url(#bgblur_0_1992_28141_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-figma-bg-blur-radius": 8,
			d: "M21.3623 31.0952C29.1728 31.0954 35.6947 36.6028 37.2627 43.9438L37.3203 44.2388C37.5826 45.5881 36.5186 46.854 35.1221 46.854H7.59766C6.20117 46.854 5.13714 45.5881 5.39941 44.2388C6.85356 36.7507 13.4474 31.0952 21.3623 31.0952Z",
			fill: "#94DCC8",
			fillOpacity: .6,
			stroke: "url(#paint2_linear_1992_28141)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 5.03711,
			y: 2.02344,
			width: 32.6387,
			height: 32.6382,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(4px)",
					clipPath: "url(#bgblur_1_1992_28141_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-figma-bg-blur-radius": 8,
			d: "M19.5614 10.7342C23.7633 9.74253 27.9737 12.3449 28.9655 16.5469C29.9572 20.7488 27.3547 24.9592 23.1528 25.9509C18.9509 26.9427 14.7405 24.3402 13.7488 20.1383C12.757 15.9364 15.3594 11.726 19.5614 10.7342Z",
			fill: "#94DCC8",
			fillOpacity: .6,
			stroke: "url(#paint3_linear_1992_28141)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_1992_28141_clip_path",
				transform: "translate(3.14062 -22.5952)",
				children: /* @__PURE__ */ _jsx("path", { d: "M21.3623 31.0952C29.1728 31.0954 35.6947 36.6028 37.2627 43.9438L37.3203 44.2388C37.5826 45.5881 36.5186 46.854 35.1221 46.854H7.59766C6.20117 46.854 5.13714 45.5881 5.39941 44.2388C6.85356 36.7507 13.4474 31.0952 21.3623 31.0952Z" })
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_1_1992_28141_clip_path",
				transform: "translate(-5.03711 -2.02344)",
				children: /* @__PURE__ */ _jsx("path", { d: "M19.5614 10.7342C23.7633 9.74253 27.9737 12.3449 28.9655 16.5469C29.9572 20.7488 27.3547 24.9592 23.1528 25.9509C18.9509 26.9427 14.7405 24.3402 13.7488 20.1383C12.757 15.9364 15.3594 11.726 19.5614 10.7342Z" })
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_1992_28141",
				x1: 55.9989,
				y1: 40.6705,
				x2: 29.6777,
				y2: 40.6705,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00897B" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#50AE9C"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_1992_28141",
				x1: 49.4769,
				y1: 24.2096,
				x2: 36.2031,
				y2: 24.2096,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00897B" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#50AE9C"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_1992_28141",
				x1: 3.20931,
				y1: 31.7922,
				x2: 11.1236,
				y2: 55.595,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: .765625,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_1992_28141",
				x1: 10.815,
				y1: 13.5057,
				x2: 26.7373,
				y2: 28.6179,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: .765625,
					stopColor: "white",
					stopOpacity: 0
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgUsersIllustration);
export { ForwardRef as ReactComponent };
